export default "__VITE_ASSET__50c5a4ba__"